'use strict';

const Ingest = require('./lib/Ingest');

module.exports = Ingest;
